import dayjs from 'dayjs';

export const DATE_TIME_FORMAT = 'D MMM YYYY HH:mm';
export const DATE_FORMAT = 'DD-MM-YYYY';
export const INSTANT_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';

export const INSTANT_FIRST_DAY_OF_THE_YEAR = `${dayjs().startOf('year').format(INSTANT_FORMAT)}Z`;
export const INSTANT_TODAY = `${dayjs().format(INSTANT_FORMAT)}Z`;
